import { createSlice } from "@reduxjs/toolkit";

const initialState = "";

const mainSlice = createSlice({
  name: "main",
  initialState,
  reducers:{
    setTitle(state, action){
      return action.payload
    }
  }
});

export const {setTitle} = mainSlice.actions
export default mainSlice.reducer;
